import styles from './AddNotecardCategoryButton.module.less'
import React, { ReactElement, useState } from 'react'
import { Button, Modal } from 'antd'
import { PlusCircleOutlined } from '@ant-design/icons'
import { AddNotecardCategory } from '@/components/NotecardCategories/AddNotecardCategoryButton/AddNotecardCategory/AddNotecardCategory'
import { useRecoilValue } from 'recoil'
import { isActiveCourseReadOnlySelector } from '@/atoms/auth'

export const AddNotecardCategoryButton: React.FC<
    unknown
> = (): ReactElement => {
    const isReadOnly = useRecoilValue(isActiveCourseReadOnlySelector)
    const [isModalVisible, setIsModalVisible] = useState<boolean>(false)

    return (
        <div className={styles.addNotecardCategoryButtonContainer}>
            <Button
                onClick={() => setIsModalVisible(true)}
                size={'large'}
                disabled={isReadOnly}
            >
                <PlusCircleOutlined /> <span>Add notecard category</span>
            </Button>
            <Modal
                open={isModalVisible}
                onCancel={() => setIsModalVisible(false)}
                footer={null}
                destroyOnClose={true}
            >
                <AddNotecardCategory
                    closeModal={() => setIsModalVisible(false)}
                />
            </Modal>
        </div>
    )
}
